import { render, staticRenderFns } from "./correct-revie-end-date-notification.vue?vue&type=template&id=7d432d22&lang=pug&"
import script from "./correct-revie-end-date-notification.vue?vue&type=script&lang=ts&"
export * from "./correct-revie-end-date-notification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports